import { styled } from 'styled-components';
import { motion } from 'framer-motion';

export const Form = styled.form`
  width: 100%;
  max-width: 100%;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  gap: 2rem;

  p {
    text-align: center;

    a {
      color: ${props => props.theme.brand};
      transition: color ${props => props.theme.transition};
      &:hover {
        color: ${props => props.theme.textColor};
      }
    }
  }


  @media only screen and (min-width: ${props => props.theme.breakpoints.width.md}) {
    max-width: ${props => props.theme.breakpoints.width.sm};
  }

  @media only screen and (min-width: ${props => props.theme.breakpoints.width.lg}) {
    max-width: ${props => props.theme.breakpoints.width.md};
  }
`;

export const FormSection = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spaceMd};
`;

export const FormSeparator = styled(motion.span)`
  margin: 0 auto;
  position: relative;
  border: none;

  &,
  &::before,
  &::after {
    width: 8px;
    height: 8px;
    background-color: ${props => props.theme.mutedColor};
    border-radius: ${props => props.theme.borderFull};
  }
  &::before,
  &::after {
    position: absolute;
    content: '';
    top: 0;
  }

  &::before {
    left: -${props => props.theme.spaceXl};
  }

  &::after {
    left: ${props => props.theme.spaceXl};
  }
`;

export const SubmitWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spaceSm};
  margin-top: ${props => props.theme.spaceMd};

  p {
    font-size: ${props => props.theme.sizeSmall};
    color: ${props => props.theme.mutedColor};
  }
`;

export const SuccessWrapper = styled(motion.div)`
  height: 100%;
  padding: ${props => props.theme.spaceXl};
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${props => props.theme.spaceXl};

  hgroup {
    display: flex;
    flex-direction: column;
    gap: ${props => props.theme.spaceMd};
    text-align: center;
  }
`;
